interface ErrorBannerProps {
  message: string | null;
  onDismiss: () => void;
}

export function ErrorBanner({ message, onDismiss }: ErrorBannerProps) {
  if (!message) return null;
  return (
    <div className="error-banner">
      {message}
      <button
        className="secondary"
        style={{ float: "right", padding: "2px 8px" }}
        onClick={onDismiss}
      >
        關閉
      </button>
    </div>
  );
}
